import Typography from "@material-ui/core/Typography";
import FilterHistory from "../../../../../../shared/components/filter-history/FilterHistory";
import {updateObject} from "../../../../../../shared/utils/updateObject";
import {filterInitialState, headCells, sortingCriteria} from "./AssociateRemoveSimServerSideModalHelper";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import SortingDropdown from "../../../../../../shared/components/sorting-dropdown/SortingDropdown";
import ButtonWithProgress from "../../../../../ui/buttons/button-with-progress/ButtonWithProgress";
import SimClientSideFilter
    from "../../../../../../shared/components/sim-client-side-table-and-filter/sim-client-side-filter/SimClientSideFilter";
import SimServerSideTable from "../../../../../../shared/components/sim-server-side-table/SimServerSideTable";

const AssociateRemoveSimServerSideModal = (props) => {
    const handleConfirmClick = () => {
        props.handleConfirmClick();
    }

    const handleTablePaginationChange = (page, rowsPerPage) => {
        props.setPage(page);
        props.setRowsPerPage(rowsPerPage);
    }

    const handleSortingChange = (value) => {
        props.setSorting(value);
        props.setPage(0);
    }

    const handleFilterSearch = (name, value) => {
        props.setCurrentFilterHistory((currentFilterHistory) => (updateObject(currentFilterHistory, {
            [name]: {
                ...currentFilterHistory[name],
                value: Array.isArray(currentFilterHistory[name].value) ? [...currentFilterHistory[name].value, value] : value
            }
        })))
    }

    const handleResetFilter = () => {
        props.setCurrentFilterHistory(filterInitialState);
    }

    const handleFilterSelectsSearch = (value) => {
        props.setCurrentFilterHistory(prevFilterHistory => updateObject(prevFilterHistory, value))
    }

    const handleRemoveBadge = (key, type, index) => {
        props.setCurrentFilterHistory(currentFilterHistory => updateObject(currentFilterHistory, {
            [key]: {
                ...currentFilterHistory[key],
                value: type === "primitive" ? "" : [...currentFilterHistory[key].value].filter((i, idx) => idx !== index)
            }
        }))
    }

    return (
        <>
            <Typography variant="body2">
                {props.description}
            </Typography>

            <SimClientSideFilter handleSearchIcon={handleFilterSearch}
                                 filter={props.currentFilterHistory}
                                 showFilterButton={props.showFiltriButton}
                                 isFromContratto={props.isFromContratto}
                                 isOption={props.isOption}
                                 handleSelectSearch={handleFilterSelectsSearch}/>

            <FilterHistory filter={props.currentFilterHistory}
                           removeFilter={handleRemoveBadge}
                           resetFilter={handleResetFilter}/>

            <Grid container
                  className={"mb-6"}
                  justifyContent="space-between"
                  alignItems="center">
                <SortingDropdown sortingValue={props.sorting}
                                 changeSortingCriteria={handleSortingChange}
                                 sortingCriteria={sortingCriteria}/>

                <ButtonWithProgress variant="contained"
                                    loading={props.buttonLoading}
                                    color="primary"
                                    disabled={!props.selectedSims.length || props.disableConfirmBtn || props.areAllSelected}
                                    text="Conferma"
                                    handleClick={handleConfirmClick}/>
            </Grid>

            <SimServerSideTable
                tableData={props.tableData}
                selected={props.selectedSims}
                setSelected={props.setSelectedSims}
                page={props.page}
                rowsPerPage={props.rowsPerPage}
                loading={props.loading}
                order={props.sorting}
                count={props.count}
                filter={props.currentFilterHistory}
                handlePaginationChange={handleTablePaginationChange}
                areAllSelected={props.areAllSelected}
                setAreAllSelected={props.setAreAllSelected}
                headCells={headCells}
            />
        </>
    )
}

AssociateRemoveSimServerSideModal.propTypes = {
    tableData: PropTypes.arrayOf(
        PropTypes.shape({
            seriale: PropTypes.string.isRequired,
            numeroDiTelefono: PropTypes.string.isRequired,
            piano: PropTypes.string.isRequired,
            tags: PropTypes.array.isRequired
        })
    ).isRequired,
    handleConfirmClick: PropTypes.func.isRequired,
    disableConfirmBtn: PropTypes.bool,
    selectedSims: PropTypes.array.isRequired,
    setSelectedSims: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    buttonLoading: PropTypes.bool.isRequired,
    description: PropTypes.string,
    showFiltriButton: PropTypes.bool,
    count: PropTypes.number.isRequired,
    setPage: PropTypes.func.isRequired,
    setRowsPerPage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    setSorting: PropTypes.func.isRequired,
    sorting: PropTypes.string.isRequired,
    setCurrentFilterHistory: PropTypes.func.isRequired,
    currentFilterHistory: PropTypes.object.isRequired,
    areAllSelected: PropTypes.bool.isRequired,
    setAreAllSelected: PropTypes.func.isRequired
}

AssociateRemoveSimServerSideModal.defaultProps = {
    loading: false,
    disableConfirmBtn: false,
    showFiltriButton: true
}

export default AssociateRemoveSimServerSideModal
